// Shim: next/link → react-router-dom Link
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

interface NextLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string
  replace?: boolean
  prefetch?: boolean
  scroll?: boolean
  children?: React.ReactNode
}

const Link = React.forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ href, replace: _replace, prefetch: _prefetch, scroll: _scroll, ...props }, ref) => {
    return <RouterLink ref={ref} to={href} {...props} />
  }
)

Link.displayName = 'Link'

export default Link
